module.exports = __webpack_public_path__ + "img/yangyi.e38611d5.png";